export const healthCard = [
  {
    title: 'Health Screening Tools',
    description:
      'Choose one of our tools below to be guided on possible conditions and next steps. Early detection of a health issue can prevent worsening of symptoms and lead to better physical and mental well-being.',
    img: require('@assets/images/safehaven/health-help/Welcome02.svg'),
    services: [
      {
        title: 'Health Checker',
        description:
          'Let our advanced analytics help provide you with insights and next steps for your symptoms.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_InstantHealthCheck.svg'),
        url: 'https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S',
        isActivationPending: false,
        isComingSoon: false,
      },
      {
        title: 'Depression',
        description:
          'Identify depression early and seek appropriate care. If you are having suicidal thoughts, please call the Suicide & Crisis hotline 988.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_MentalHealthCheck.svg'),
        url: 'quetionnaire',
        isActivationPending: false,
        isComingSoon: false,
      },
      {
        title: 'Talk with Serea',
        description:
          'Share how you are feeling with Serea and receive insights into your best next steps.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Serea.svg'),
        url: 'https://myhealthbookplus.com/serea',
        isActivationPending: false,
        isComingSoon: true,
      },
      {
        title: 'Anxiety',
        description:
          'Identify anxiety early and seek appropriate care. If you are having suicidal thoughts, please call the Suicide and Crisis hotline 988.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Anxiety.svg'),
        url: '',
        isActivationPending: false,
        isComingSoon: true,
      },
      {
        title: 'Cognitive Decline',
        description:
          'Take a speech-based assessment to identify early cognitive decline and seek appropriate care.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Cognitive.svg'),
        url: '',
        isActivationPending: false,
        isComingSoon: true,
      },
      {
        title: 'Instant Biometric Scan',
        description:
          'Use your mobile device camera to capture a 30 second scan of your face and obtain reliable biometrics.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Biometric.svg'),
        url: '',
        isActivationPending: false,
        isComingSoon: true,
      },
    ],
  },
  {
    title: 'Contact a Provider',
    description:
      'Seek professional advice, diagnosis and treatment for your specific health concerns. Healthcare providers can offer you personalized guidance, treatment plans and referrals to other specialists.',
    img: require('@assets/images/safehaven/health-help/Welcome03.svg'),
    services: [
      {
        title: 'Telehealth',
        description:
          'We will connect you with the right healthcare provider for help with any condition.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Telehealth.svg'),
        url: 'telehealth',
        isActivationPending: true,
        isComingSoon: false,
      },
      {
        title: 'Secure Chat',
        description:
          'A private, safe option to immediately discuss your healthcare concerns with a clinician.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_SecureChat.svg'),
        url: 'peer-coaching',
        isActivationPending: true,
        isComingSoon: false,
      },
      {
        title: 'Contact My Provider',
        description:
          'Get in touch with your provider to diagnose, treat, and prescribe. ',
        img: require('@assets/images/safehaven/health-help/HealthHelp_SecureChat.svg'),
        url: 'peer-coaching',
        isActivationPending: true,
        isComingSoon: false,
      },
    ],
  },
  {
    title: 'Educational Materials',
    description:
      'Empower yourself to make informed decisions about your health and well-being with topics covering preventative measures, disease management, mental health, nutrition and fitness.',
    img: require('@assets/images/safehaven/health-help/Welcome05.svg'),
    services: [
      {
        title: 'Read articles',
        description:
          'Comprehensive, evidence-based materials to help you along your health journey.',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Articles.svg'),
        url: 'https://healthbookplus.com/index.php/all-posts/',
        isActivationPending: false,
        isComingSoon: false,
      },
      {
        title: 'Watch videos',
        description:
          'View curated videos on informative health and wellness topics',
        img: require('@assets/images/safehaven/health-help/HealthHelp_Videos.svg'),
        url: '',
        isActivationPending: false,
        isComingSoon: true,
      },
    ],
  },
]
